import { Model } from '../../shared-features/models/model';
import { Expose } from 'class-transformer';
import { ShipmentList } from './shipment-list';

export class ShipmentsModel extends Model {
  @Expose() shipments: ShipmentList[] = [];
}
